import { useState } from 'react';
import { FaArrowDown, FaExpandArrowsAlt } from 'react-icons/fa';
import { CtaButtons } from '../components/landing';
import { PillButtons, Button } from '../components/input';
import { CodeBlock } from '../components/code';
import { narrow } from '../shared';
import { discordUrl } from '../constants';

const headerStyle = {
  fontWeight: 'bold',
  fontSize: 36,
  textAlign: 'center',
  marginBottom: 20,
};

const ApiCall = () => {
  const [tab, setTab] = useState('python');

  const codeStyle = {
    // display: 'inline-block',
    // width: 560,
    // whiteSpace: 'pre',
    // fontFamily: 'monospace',
    // background: '#f3f3f3',
    // borderRadius: 4,
  };

  const choices = [
    ['python', 'Python'],
    ['javascript', 'JavaScript'],
    ['bash', 'curl'],
  ];

  const code = {
    python: `# pip install fetchfox-sdk

from fetchfox_sdk import FetchFox

fox = FetchFox(api_key="your_api_key")

data = fox.scrape({
  "pattern": 'https://www.reddit.com/r/*/comments/*',
  "template": "username, comment, points",
})`,

    javascript: `// npm install fetchfox-sdk

import * as fox from 'fetchfox-sdk';

fox.configure({ apiKey: 'your_api_key' })

const data = await fox.scrape({
  pattern: 'https://www.reddit.com/r/*/comments/*',
  template: 'username, comment, points'
})`,

    bash: `curl -X POST https://api.fetchfox.ai/api/scrape \\
  -H "Content-Type: application/json" \\
  -H "Authorization: Bearer $FETCHFOX_API_KEY" \\
  -d '{"pattern":"https://www.reddit.com/r/*/comments/*",
       "template": "username, comment, points"}'`,
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 10 }}>
      <div style={{ color: '#888', fontSize: 14, textAlign: 'center', lineHeight: 1.1 }}>
        Forget CSS hacks and bot blocks.
        <br />
        AI + FetchFox is all you need.
      </div>

      <br />

      <PillButtons choices={choices} value={tab} onChange={setTab} />
      <CodeBlock language={tab}>{code[tab]}</CodeBlock>
      <FaArrowDown size="36" color="#888" />
      <CodeBlock language="json">
        {`{
    "username": "BobbyUser",
    "comment_text": "AI + FetchFox = 🤩",
    "points": 888
}`}
      </CodeBlock>

      <div style={{ color: '#888', fontSize: 14, margin: '40px 0 0 0' }}>🪦 BeautifulSoup 2004-2025, RIP</div>
    </div>
  );
};

export default function Landing() {
  return (
    <div>
      <div style={{ textAlign: 'center', marginBottom: 20 }}>
        <img src="/logo-fox.svg" style={{ width: 60 }} />
        <div style={{ ...headerStyle, marginTop: 20, marginBottom: 8 }}>
          Scrape <mark>millions of items</mark>
        </div>
        <div style={headerStyle}>
          with <mark>one line of code</mark>
        </div>
      </div>

      <br />

      {narrow(<ApiCall />)}

      <br />

      <CtaButtons />

      <br />
      <br />

      <div style={{ margin: '40px auto 200px auto', width: 640, textAlign: 'center', fontSize: 18 }}>
        FetchFox is a new
        <div style={{ margin: '18px 0 10px 0' }}>
          <FaArrowDown size="24" color="#aaa" />
        </div>
        Get free 1:1 support on{' '}
        <a href={discordUrl} className="bold">
          Discord
        </a>{' '}
        or at{' '}
        <a href="mailto:help@fetchfoxai.com" className="bold">
          help@fetchfoxai.com
        </a>
      </div>
    </div>
  );
}
